import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";

class BackButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleBackClick = this._handleBackClick.bind(this);
  }

  _handleBackClick() {
    const { history } = this.props;

    if (history && history.length > 1) {
      history.goBack();
    } else if (window.history.length > 1) {
      window.history.back();
    }
  }

  render() {
    const { history, staticContext, ...props } = this.props;

    return (
      <Button
        {...props}
        className="back-button"
        onClick={this.handleBackClick}
        variant="secondary"
      >
        <i className="fa fa-angle-left" /> Back
      </Button>
    );
  }
}

BackButton.propTypes = {
  history: PropTypes.object,
};

export default withRouter(BackButton);
export { BackButton };
